__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "agents";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("next/dynamic", "13.3.4", function() { return __webpack_require__.e(3502).then(function() { return function() { return __webpack_require__(53502); }; }); });
			register("next/head", "13.3.4", function() { return __webpack_require__.e(7526).then(function() { return function() { return __webpack_require__(27526); }; }); });
			register("next/link", "13.3.4", function() { return __webpack_require__.e(7076).then(function() { return function() { return __webpack_require__(67076); }; }); });
			register("next/router", "13.3.4", function() { return __webpack_require__.e(8373).then(function() { return function() { return __webpack_require__(68373); }; }); });
			register("next/script", "13.3.4", function() { return __webpack_require__.e(6189).then(function() { return function() { return __webpack_require__(86189); }; }); });
			register("react-dom", "18.2.0", function() { return function() { return __webpack_require__(10422); }; });
			register("react/jsx-runtime", "18.2.0", function() { return __webpack_require__.e(1527).then(function() { return function() { return __webpack_require__(11527); }; }); });
			register("react", "18.2.0", function() { return function() { return __webpack_require__(50959); }; });
			register("styled-components", "5.3.9", function() { return function() { return __webpack_require__(29383); }; }, 1);
			register("styled-jsx/style", "5.1.1", function() { return __webpack_require__.e(480).then(function() { return function() { return __webpack_require__(20480); }; }); });
			register("styled-jsx", "5.1.1", function() { return __webpack_require__.e(7719).then(function() { return function() { return __webpack_require__(97719); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};